var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VscrollItemBigBox",on:{"click":_vm.itemClick}},[_c('span',[_vm._v(_vm._s(_vm.myString)+" ")]),_c('span',{staticClass:"textLink"},[_vm._v(_vm._s(_vm.source.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }